import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Seo from "@/seo/Seo";

interface PageLayoutProps {
  children: ReactNode;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

const PageLayout = ({ children, jsonLd }: PageLayoutProps) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Seo jsonLd={jsonLd} />
      <Header />
      <main className="flex-1 pt-20 sm:pt-[calc(2.25rem+5rem)] md:pt-[calc(2.25rem+6rem)]">{children}</main>
      <Footer />
    </div>
  );
};

export default PageLayout;
